<template>
    <div class="content-with-margin">
        <template v-if="!uploading">
            Selected files will be uploaded:
            <div v-for="(file, idx) in uploadedFiles">
                <input type="checkbox" v-model="selectedFiles[idx]"/>{{file.name}}
            </div>

            <br/>
            <simple-layout horizontal>
                <simple-button @press="cancel">{{$t("cancel")}}</simple-button>
                <simple-button @press="upload">Upload</simple-button>
            </simple-layout>
        </template>
        <template v-else-if="uploading">
            <div style="display: flex; align-items: center; flex-flow: column;">
                <icon name="cog" scale="3" spin/>
                <br/>
                Uploading {{this.selectedFiles.filter(f => f).length}} files...
            </div>
        </template>
    </div>
</template>

<script>
    import SimpleButton from "../button/SimpleButton";
    import SimpleLayout from "../layout/SimpleLayout";
    import Axios from 'axios'
    export default {
        name: "FileUploadComponent",
        props: ['uploadedFiles', 'uploadCallback'],
        components: {SimpleLayout, SimpleButton},
        data: function () {
            return {
                selectedFiles: [],
                uploading: false
            }
        },
        watch: {
            uploadedFiles: {
                immediate: true,
                deep: true,
                handler() {
                    if(typeof this.uploadedFiles != 'undefined' && this.uploadedFiles != null)
                        this.selectedFiles = new Array(this.uploadedFiles.length).fill({}).map(() => true);
                }
            }
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            },
            upload() {
                let url = 'resource/api/v1/files'

                this.uploading = true;
                Promise.all(this.selectedFiles.map((file, idx) => {
                    let formData = new FormData();
                    formData.append('file', this.uploadedFiles[idx]);
                    return Axios.post(url, formData, {headers: {
                            'Content-Type': 'multipart/form-data'
                        }})
                        .then(res => res.data)
                        .then(res => res)
                        ;
                }))
                    .then(res => {
                        if(typeof this.uploadCallback === 'function')
                            this.uploadCallback(res);
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

    .modal-window {
        background-color: white;
        padding: 10px 10px 10px 10px;
        border-radius: 10px;
        border: 1px solid $openRed;
    }
</style>
